import getLangLocale from 'I18n/utils/getLangLocale';
import { useMemo } from 'react';
import { useGetAllPublishedQuery, useGetRelevantPublishedCalloutIdsQuery } from '../../../__generated__/chirp/com/hubspot/marketplace/quality/rpc/FeaturedCalloutsRpc.hooks';
import { useGetAllPublishedQuery as useGetAllPublishedQueryPublic, useGetRelevantPublishedCalloutIdsQuery as useGetRelevantPublishedCalloutIdsQueryPublic } from '../../../__generated__/chirp/com/hubspot/marketplace/quality/rpc/FeaturedCalloutsPublicRpc.hooks';
import { getDataFetchingClientRequestState } from '../../dataFetchingClient/utils/getDataFetchingClientRequestState';
const MAX_FEATURED_CALLOUTS = 2;
export function useFeaturedCallouts({
  appContext,
  offeringType
}) {
  const isPublic = appContext === 'public';
  const productType = offeringType;
  const relevantIdsQueryApp = useGetRelevantPublishedCalloutIdsQuery({
    variables: {
      productType
    },
    skip: isPublic
  });
  const relevantIdsQueryPublic = useGetRelevantPublishedCalloutIdsQueryPublic({
    variables: {
      productType
    },
    skip: !isPublic
  });
  const calloutsQueryApp = useGetAllPublishedQuery({
    variables: {
      productType
    },
    skip: isPublic
  });
  const calloutsQueryPublic = useGetAllPublishedQueryPublic({
    variables: {
      productType,
      locale: getLangLocale()
    },
    skip: !isPublic
  });
  const relevantIdsQuery = isPublic ? relevantIdsQueryPublic : relevantIdsQueryApp;
  const calloutsQuery = isPublic ? calloutsQueryPublic : calloutsQueryApp;
  const data = useMemo(() => {
    var _calloutsQuery$data, _relevantIdsQuery$dat, _relevantIdsQuery$dat2;
    const callouts = (_calloutsQuery$data = calloutsQuery.data) === null || _calloutsQuery$data === void 0 ? void 0 : _calloutsQuery$data.callouts;
    if (!callouts) {
      return [];
    }
    const relevantIdsSet = new Set((_relevantIdsQuery$dat = (_relevantIdsQuery$dat2 = relevantIdsQuery.data) === null || _relevantIdsQuery$dat2 === void 0 ? void 0 : _relevantIdsQuery$dat2.calloutIds) !== null && _relevantIdsQuery$dat !== void 0 ? _relevantIdsQuery$dat : []);
    return callouts.filter(callout => relevantIdsSet.has(callout.id)).slice(0, MAX_FEATURED_CALLOUTS);
  }, [calloutsQuery.data, relevantIdsQuery.data]);
  const loading = relevantIdsQuery.loading || calloutsQuery.loading;
  const error = relevantIdsQuery.error || calloutsQuery.error;
  const requestState = getDataFetchingClientRequestState(error, loading);
  return {
    data,
    requestState
  };
}